import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import { GiHamburgerMenu } from 'react-icons/gi'
import { Link } from 'react-router-dom'
import { BsClockHistory } from 'react-icons/bs'
import { LuLayoutDashboard } from 'react-icons/lu'
import { TbCoins, TbUsers } from 'react-icons/tb'
import { FaTag, FaShieldAlt } from 'react-icons/fa'
import { ImPaypal } from 'react-icons/im'
import { MdOutlineClose, MdSupportAgent } from 'react-icons/md'
import { FiAtSign } from 'react-icons/fi'
import { HiSupport } from 'react-icons/hi'
import { LiaClipboardListSolid } from 'react-icons/lia'
import { checkConfigPermissions } from '../../_helpers'
import { AiOutlineTransaction } from 'react-icons/ai'

const sideBarMenuList = [
  {
    label: 'Dashboard',
    icon: <LuLayoutDashboard size={20} />,
    key: 'dashboard'
  },
  {
    label: 'User Management',
    icon: <TbUsers size={20} />,
    key: 'userManagement'
  },
  {
    label: 'KYC Management',
    icon: <img src='/img/kycVeri.png' alt='KYC Management Icon' />,
    key: 'kycManagement'
  },
  {
    label: 'Redeem Bank Request (Individual)',
    icon: (
      <img
        src='/img/redeemReq1.png'
        alt='Redeem Bank Request Individual Icon'
      />
    ),
    key: 'redeemRequestIndividual'
  },
  {
    label: 'Redeem Bank Request (Merchant)',
    icon: (
      <img src='/img/redeemReq2.png' alt='Redeem Bank Request Merchant Icon' />
    ),
    key: 'redeemRequestMerchant'
  },
  {
    label: 'Redeem Amount (Individual)',
    icon: <img src='/img/redeemAmt2.png' alt='Redeem Amount Individual Icon' />,
    key: 'redeemAmountIndividual'
  },
  {
    label: 'Redeem Amount (Merchant)',
    icon: <img src='/img/redeemAmt1.png' alt='Redeem Amount Merchant Icon' />,
    key: 'redeemAmountMerchant'
  },
  {
    label: 'Wallet to Wallet',
    icon: <img src='/img/w2w.png' alt='Wallet to Wallet Icon' />,
    key: 'walletToWallet'
  },
  {
    label: 'Swap History',
    icon: <img src='/img/swap.png' alt='Swap History Icon' />,
    key: 'swapHistory'
  },
  {
    label: 'Add Fund (Express History)',
    icon: <img src='/img/funcadd.png' alt='Add Fund or Express History Icon' />,
    key: 'addFundExpressHistory'
  },
  {
    label: 'Express Checkout History',
    icon: <img src='/img/express.png' alt='Express Checkout History Icon' />,
    key: 'expressCheckoutHistory'
  },
  // {
  //   label: 'Merchant Seller History',
  //   icon: (
  //     <img src='/img/merchantSeller.png' alt='Merchant Seller History Icon' />
  //   ),
  //   key: 'merchantSellerHistory'
  // },
  {
    label: 'Merchant Payment History',
    icon: (
      <img src='/img/merchantBuyer.png' alt='Merchant Buyer History Icon' />
    ),
    key: 'merchantBuyerHistory'
  },
  {
    label: 'P2P History',
    icon: <img src='/img/p2phistory.png' alt='P2P History Icon' />,
    key: 'p2pHistory'
  },
  {
    label: 'Fees Setting',
    icon: <img src='/img/feessetting.png' alt='Fees Setting Icon' />,
    key: 'feesSetting'
  },
  {
    label: 'Merchant Apps',
    icon: <img src='/img/fi_7075369.png' alt='Merchant Apps Icon' />,
    key: 'merchantApps'
  },
  {
    label: 'Merchant Charges',
    icon: <img src='/img/merchantcharges.png' alt='Merchant Charges Icon' />,
    key: 'merchantCharges'
  },
  // {
  //   label: 'Supply / Mined (PKRD)',
  //   icon: (
  //     <img src='/img/SupplyMined (PKRD).png' alt='Supply or Mined PKRD Icon' />
  //   ),
  //   key: 'supplyMinedPKRD'
  // },
  // {
  //   label: 'Alt Wallet Holdings',
  //   icon: <img src='/img/altwallet.png' alt='Alt Wallet Holdings Icon' />,
  //   key: 'altWalletHoldings'
  // },
  {
    label: 'Admin User Management',
    icon: (
      <img src='/img/adminuseraccess.png' alt='Admin User Management Icon' />
    ),
    key: 'adminUsersManagement'
  },
  {
    label: 'Merchant Approved (API)',
    icon: (
      <img src='/img/merchantApporved.png' alt='Merchant Approved API Icon' />
    ),
    key: 'merchantApprovedAPI'
  },
  {
    label: 'Monitoring Unit',
    icon: <TbUsers size={20} />,
    key: 'monitoringUnit'
  },
  {
    label: 'Payment Gateway',
    icon: <img src='/img/paymentgateway.png' alt='Payment Gateway Icon' />,
    key: 'paymentGateway'
  },
  // { label: 'CS Email', icon: <img src='/img/csemail.png' alt='Customer Support Email Icon' />, key: "csEmail" },
  {
    label: 'Customer support',
    icon: <img src='/img/csemail.png' alt='Customer Support Email Icon' />,
    key: 'customer-support'
  },

  // {
  //   label: 'Backups',
  //   icon: <img src='/img/backups.png' alt='Backups Icon' />,
  //   key: 'backups'
  // },
  // {
  //   label: 'Restrict Acct Unusual Activity',
  //   icon: (
  //     <img
  //       src='/img/Group 1707479029.png'
  //       alt='Restrict Account Unusual Activity Icon'
  //     />
  //   ),
  //   key: 'restrictAcctUnusualActivity'
  // },
  {
    label: 'Upcoming ID Expires',
    icon: <img src='/img/fi_6117203.png' alt='Upcoming ID Expiry Icon' />,
    key: 'upcomingIDExpires'
  },
  {
    label: 'Coin Management',
    icon: <TbCoins size={20} />,
    key: 'coinManagement'
  },
  {
    label: 'Fiat Management',
    icon: <FiAtSign size={20} />,
    key: 'fiatManagement'
  },
  {
    label: 'Security Questions',
    icon: <FaShieldAlt size={20} />,
    key: 'securityQuestion'
  },
  {
    label: 'Dispute Category',
    icon: <HiSupport size={20} />,
    key: 'disputeCategory'
  },
  {
    label: 'Dispute Message',
    icon: <MdSupportAgent size={20} />,
    key: 'disputeMessage'
  },
  {
    label: 'P2P Dispute',
    icon: <LiaClipboardListSolid size={20} />,
    key: 'p2p-dispute'
  },
  {
    label: 'Transaction Dispute',
    icon: <AiOutlineTransaction size={20} />,
    key: 'disputeRaisedList'
  },
  { label: 'Terms Tags', icon: <FaTag size={20} />, key: 'termAndTags' },
  {
    label: 'Payment Method',
    icon: <ImPaypal size={20} />,
    key: 'paymentMethod'
  },
  {
    label: 'Login History',
    icon: <BsClockHistory size={20} />,
    key: 'loginHistory'
  }
  // { label: 'App Setting', icon: <MdAppSettingsAlt size={20} />, key: "appSetting" },
]

const Sidebar = () => {
  const location = useLocation()
  const [navbarOpen, setNavbarOpen] = useState(false)
  const dropdownRef = useRef(null)

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setNavbarOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className='relative h-full'>
      <button
        className={`absolute top-4 left-4 p-2 mt-1 bg-green-600 text-white rounded-full shadow-md xl:hidden z-50 transition-transform duration-200 ${navbarOpen ? 'scale-0' : 'scale-100'
          }`}
        onClick={() => setNavbarOpen(true)}
      >
        <GiHamburgerMenu size={22} />
      </button>

      {/* Sidebar */}
      <div
        ref={dropdownRef}
        className={`fixed xl:static left-0 top-0 h-full w-72 xl:w-80 bg-white border-r border-gray-200   transform transition-transform duration-300 ease-in-out z-40 ${navbarOpen ? 'translate-x-0' : '-translate-x-full xl:translate-x-0'
          }`}
      >
        {/* Top Bar */}
        <div className='flex items-center justify-between py-3 px-2 border-b border-gray-200'>
          <img src='/sidebarimage.png' alt='Logo' className=' object-contain' />
          <div className='bg-[#15A14A26] xl:hidden rounded-full flex justify-center items-center h-7 w-7 text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
            <MdOutlineClose
              size={20}
              className=' cursor-pointer'
              onClick={() => setNavbarOpen(false)}
              title='Close'
            />
          </div>
        </div>

        {/* Menu List */}
        <div className='overflow-y-auto max-h-100
  [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:bg-green-600/50 [&::-webkit-scrollbar-thumb]:rounded-full h-[calc(98vh-72px)]'>
          <ul className='space-y-1'>
            {sideBarMenuList
              .filter(per => checkConfigPermissions(per.key))
              .map((item, index) => {
                const isActive =
                  location.pathname ===
                  `/app/${item.label.replace(/\s+/g, '-').toLowerCase()}`
                return (
                  <li key={index}>
                    <Link
                      to={`/app/${item.label
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`}
                      onClick={() => setNavbarOpen(false)}
                      className={`flex items-center gap-3 px-4 py-2 capitalize font-medium transition-all duration-200 ${isActive
                        ? 'bg-[#00811D1A] text-green-600 border-l-4 border-l-green-800'
                        : 'hover:bg-[#00811D1A] text-[#2D2D2D] hover:text-[#00811D]'
                        }`}
                    >
                      <div className='w-5 h-5 flex-shrink-0'>{item.icon}</div>
                      <span className='truncate'>{item.label}</span>
                    </Link>
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Sidebar
